<template>
  <div>

    <Spinner v-if="loading === true" />
    <div
        v-if="loading === false"
        class="row"
    >
      <div class="col-md-6" />
      <div class="col-md-6 create-button" />
    </div>
    <basic-table
        v-if="loading === false"
        :selectedPage = "''"
        @changeStatus="updateStatus($event)"
        ref="table"
        :columns="columns"
        :values="rows"
        @getAction="navigate($event)"
    />
  </div>
</template>
<script>
import BasicTable from '../../../shared/tables/BasicTable.vue'
import contractsRequestsService from '../../../services/contractsRequestsService'
import Spinner from '@/shared/loader/Spinner'

export default {
  components: {
    Spinner,
    BasicTable,
  },
  data() {
    return {
      loading: false,
      editedService: '',
      columns: [
        {
          label: 'Owner ',
          field: 'contract.user.full_name',
        },
        {
          label: 'Project',
          field: 'contract.project.name',
        },
        {
          label: 'Project Status',
          field: 'contract.project.project_status.name',
        },
        {
          label: 'Request Status',
          field: 'status',
        },

      ],
      rows: [],
      searchTerm: '',
    }
  },
  created() {
    this.getRequests()
  },

  methods: {
    navigate(row) {
      window.location.href="/projects/"+row.contract.project.id+"/edit"
    },
    getRequests(withLoading = true) {
      this.loading = true
      contractsRequestsService.cancelRequests().then(response => {
        this.rows = response.data.data
        console.log(this.rows)
        this.loading = false
      })
    },
    updateStatus(row){
      console.log(row)
      this.confirmChangeStatusText(row)
    },
    confirmChangeStatusText(row) {
      if (row.id !== null && row.id !== undefined ) {
        this.$swal({
          title: 'Are you sure of changing status?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, change it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            contractsRequestsService.changeCancelStatus(row.id).then(response => {
              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: 'Changed!',
                  text: 'Status has been changed.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(() => {
                  this.renderTable()
                })
              }
            }).catch(error => {
              this.loading = false
              return Promise.reject(error)
            })
          } else if (result.dismiss === 'cancel') {
            this.$swal({
              title: 'Cancelled',
              text: '',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.loading = false
            this.renderTable()
          } else {
            this.loading = false
            this.renderTable()
          }

        })
      }
    },
    renderTable() {
      this.getRequests()
    },

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
